module.exports = __webpack_public_path__ + "resources/img/img_tcc_advantage3_m.275f333cf8e9c6985b284c578c3d638e.jpg";